// Viewport height

(function () {
    function viewportHeight(event) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`); // set the viewport height on the html getElementById
        document.documentElement.style.setProperty(
            "--header-scroll-height",
            `${document.querySelector(".main-header").scrollHeight}px`
        );
        document.documentElement.style.setProperty(
            "--header-client-height",
            `${document.querySelector(".main-header").clientHeight}px`
        );
    }
    window.addEventListener("DOMContentLoaded", viewportHeight);
})();
